import React from 'react';
import s from './ConfirmMessage.scss';
import Button from './Button';
import { URL_BASE } from '../../../config';




const ConfirmMessage = ({ message, title, children }) => {

    return (
        <div className={s.infoWraper}>
            <h1 className={s.title}>{title}</h1>
            <p className={s.text}>{message}</p>
            {children && <a className={s.confirmLink} href={`${URL_BASE}/app/clear-app/?next_url=/prendas`}><Button children='Volver al inicio'/></a>}
        </div>
    )
};

export default ConfirmMessage;
